export function abrirJanelaPdf() {
    try {
        return window.open("", "_blank");
    } catch (e) {
        return null;
    }
}

export function abrirBlobPdf(data, janelaPdf) {
    const file = new Blob([data], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);

    if (janelaPdf && !janelaPdf.closed) {
        janelaPdf.location.href = fileURL;
        return;
    }

    const novaJanela = window.open(fileURL, "_blank");

    if (novaJanela) {
        return;
    }

    try {
        window.location.href = fileURL;
    } catch (e) {
        baixarPdf(fileURL);
    }
}

export function fecharJanelaPdf(janelaPdf) {
    try {
        if (janelaPdf && !janelaPdf.closed) {
            janelaPdf.close();
        }
    } catch (e) {
        // Alguns navegadores bloqueiam acesso a janelas criadas previamente.
    }
}

function baixarPdf(fileURL) {
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = "documento.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
